import { MagicConfigMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PROMOTIONS_NAMESPACE } from '../store/modules/promotions/promotions.store.js';
import { store } from '../store/index.js';
import { UserRolesUpdated } from '@gig/magic-common/dist/util/helpers/user';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const promotions = namespace(PROMOTIONS_NAMESPACE);
let PromotionsMixin = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isLoading = false;
  }
  fetchData() {
    return __async(this, null, function* () {
      try {
        this.isLoading = true;
        const language = this.magicConfig.language;
        yield Promise.all([
          this.fetchCategories(language),
          this.fetchEntries({
            type: this.type,
            lang: language,
            mobile: this.magicConfig.mobile
          })
        ]);
      } catch (e) {
        this.__handleDataError(e);
      } finally {
        this.isLoading = false;
      }
    });
  }
  updateEntries() {
    return __async(this, null, function* () {
      try {
        yield this.refreshEntries({
          type: this.type,
          lang: this.magicConfig.language,
          mobile: this.magicConfig.mobile
        });
      } catch (e) {
        this.__handleDataError(e);
      }
    });
  }
  __handleDataError(error) {
    return error;
  }
};
__decorateClass([
  Prop(String)
], PromotionsMixin.prototype, "type", 2);
__decorateClass([
  promotions.Getter("entries")
], PromotionsMixin.prototype, "promotions", 2);
__decorateClass([
  promotions.Getter("categories")
], PromotionsMixin.prototype, "categories", 2);
__decorateClass([
  promotions.Action("fetchCategories")
], PromotionsMixin.prototype, "fetchCategories", 2);
__decorateClass([
  promotions.Action("fetchEntries")
], PromotionsMixin.prototype, "fetchEntries", 2);
__decorateClass([
  promotions.Action("refreshEntries")
], PromotionsMixin.prototype, "refreshEntries", 2);
__decorateClass([
  Watch("magicConfig.language", { immediate: true }),
  SessionChange()
], PromotionsMixin.prototype, "fetchData", 1);
__decorateClass([
  UserRolesUpdated()
], PromotionsMixin.prototype, "updateEntries", 1);
__decorateClass([
  Emit("error")
], PromotionsMixin.prototype, "__handleDataError", 1);
PromotionsMixin = __decorateClass([
  Component({
    store
  })
], PromotionsMixin);

export { PromotionsMixin };
